import { Component, Inject, OnInit, Optional, Pipe } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { EMRService } from 'app/EMR/EMR.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-help-list-popup',
  templateUrl: './help-list-popup.component.html',
  styleUrls: ['./help-list-popup.component.scss']
})

export class HelpListPopupComponent implements OnInit {
  destroyhelplist$: Subject<boolean> = new Subject<boolean>();
  private nextreviewrocesses:any=[];
  private searchValue02: any;
  private helplistArray: any = [];
  private passmater: string = '';
  private popupDescription: string = '';
  private rowClicked: any;
  constructor(private authService:AuthService,private emrservice: EMRService, private dashboardService: DashboardService, private dialogRef: MatDialogRef<HelpListPopupComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private data: any,) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.nextreviewrocesses=[];
    this.helplistArray=[];
    this.passmater='';
    this.popupDescription='';
    if (this.data.typeid == 47) {
      this.passmater = 'ExaminationComments';
      this.gethelpListpopupdata(this.passmater);
    } else if (this.data.typeid == 8){
      this.passmater = 'Group';
      this.gethelpListpopupdata(this.passmater);
    }
    else if (this.data.typeid == 46) {
      this.passmater = 'Prognosis';
      this.gethelpListpopupdata(this.passmater)
    } else if (this.data.typeid == 51) {
      this.passmater = 'NutrionalAdvised';
      this.gethelpListpopupdata(this.passmater);
    } else if (this.data.typeid == 45) {
      this.passmater = 'TreatmentPlan';
      this.gethelpListpopupdata(this.passmater);
    } else if (this.data.typeid == 49) {
      this.passmater = 'ReferredReason';
      this.gethelpListpopupdata(this.passmater);
    } else if (this.data.typeid == 1) {
      this.passmater = 'MedicineType';
      this.gethelpListpopupdata(this.passmater);
    }else if (this.data.typeid == 52) {
      this.passmater = 'DiscountReason';
      this.gethelpListpopupdata(this.passmater);
    }
    else if(this.data.typeid =='OTDuration'){
      this.gethelpListpopupdata(this.data.typeid);
    }else if(this.data.typeid =='OTStatus'){
      this.gethelpListpopupdata(this.data.typeid);
    } else if(this.data.typeid == 18){
      this.getpopupdata(18);
    } else if(this.data.typeid == 22){
      this.getpopupdata(22);
    } else if(this.data.typeid == 27){
      this.getpopupdata(27);
    }else if(this.data.typeid == 25){
      this.getpopupdata(25);
    }else if(this.data.typeid == 2){
      this.getpopupdata(2);
    }else if(this.data.typeid == 23){
      this.getpopupdata(23);
    } else if(this.data.typeid == 29){
      this.getpopupdata(29);
    } else if(this.data.typeid == 33){
      this.getpopupdata(33);
    }else if(this.data.typeid == 'GlassPresc_Remarks'){
      this.passmater = 'GlassPresc_Remarks';
      this.gethelpListpopupdata(this.passmater);
    }else if(this.data.typeid == 44){
      this.gethelpListpopupdata('NATIONALITY');
    }else if(this.data.typeid == 14){
      this.gethelpListpopupdata('VIPREF');
    }else if(this.data.typeid == 6){
      this.gethelpListpopupdata('MARITALSTATUS');
    }else {
      this.gethelpListpopupdata(this.data.typeid);
    }
    
    this.rowClicked = -1;
  }
  ngOnDestroy() {
   
    this.destroyhelplist$.next(true);
    this.destroyhelplist$.unsubscribe();
    this.nextreviewrocesses=null;
    this.searchValue02=null;
    this.passmater=null;
    this.popupDescription=null;
    this.rowClicked=null; 
    this.helplistArray =null;
  }
  gethelpListpopupdata(type: any) {
   
    this.emrservice.GetPopUpHelp(type).pipe(takeUntil(this.destroyhelplist$)).subscribe((x: any) => {
      this.helplistArray = x.filter(item => item.isActive == true);
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
 
  // keyupSearching(value:any){
  //   if(value !='' && value !=null && value !=undefined){
  //     this.helplistArray= this.helplistArray ? this.helplistArray.filter(item => item.popupDescription.search(new RegExp(value, 'i')) > -1) : [];
  //   }else{
  //     this.ngOnInit();
  //   }
  // }
  getpopupdata(type: any) {
    this.helplistArray = [];
    this.emrservice.GetPopupMasterHelp(type).pipe(takeUntil(this.destroyhelplist$)).subscribe((x: any) => {
      this.helplistArray = x.filter(item => item.isActive == true);
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  rowdata: any = {};
  changeTableRowColor(row: any, idx: any) {

    if (this.rowClicked === idx) {
      this.popupDescription = '';
      this.rowClicked = -1;
      this.rowdata = {};
    }
    else {
      this.popupDescription = row.popupDescription;
      this.rowdata = row;
      this.rowClicked = idx;
    }

  }
  //delete pop up open 
  Cancelpopup(type) {
    if (type == 1) {
      document.getElementById("addheliplitsModal").style.display = "Block";
    } else {
      this.popupDescription = '';
      document.getElementById("addheliplitsModal").style.display = "None";
    }

  }
  optypenumber: number = 0;
  closePopup(type, optype) {
    if (type == 1) {
      this.optypenumber = optype;
      document.getElementById("updateheliplitsModal").style.display = "Block";
    } else {
      this.optypenumber = 0;
      this.popupDescription = '';
      this.rowdata = {};
      document.getElementById("updateheliplitsModal").style.display = "None";
    }
  }
  AddhelpListdata() {
    debugger
    if (this.data.typeid > 0 && this.popupDescription != '') {
      let seqno = this.helplistArray.length + 1;
      let payload = {
        "PopUpMasterGeneral":
        {
          "IsEdit": false,
          "IsDelete": false,
          "PkPopupId": 0,
          "PopupDescription": this.popupDescription,
          "FkPopupCategoryId": this.data.typeid,
          "SeqNo": seqno,
          "IsActive": true,
          "PKSynchId": null
        }
      }
     this.emrservice.InsertHelplistpopup(payload).pipe(takeUntil(this.destroyhelplist$)).subscribe(data => {
        if (data['statusCode'] == 1) {
          this.ngOnInit();
          this.popupDescription = '';
          document.getElementById("addheliplitsModal").style.display = "None";
          this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
        }else if( data['statusCode'] == 10) {
          this.dashboardService.openSnackBar("Already Exists Description", "OK");
        }else if( data['statusCode'] == 7) {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
         else {

          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      },
        err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
          // this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");

        }
      );
  
    } else {
      this.dashboardService.openSnackBar("Plz Enter Description", "OK");
    }
  }
  modifyhelpListdata() {
    if (this.data.typeid > 0 && this.popupDescription != '' && Object.keys(this.rowdata).length >= 0 && this.optypenumber > 0) {
      if (this.optypenumber == 1) {
       
        var payload = {
          "PopUpMasterGeneral":
          {
            "IsEdit": true,
            "IsDelete": false,
            "PkPopupId": this.rowdata.pkPopupId,
            "PopupDescription": this.popupDescription,
            "FkPopupCategoryId": this.data.typeid,
            "SeqNo": this.rowdata.seqNo,
            "IsActive": true,
            "PKSynchId": null
          }
        }
      } else if (this.optypenumber == 2) {
        var payload = {
          "PopUpMasterGeneral":
          {
            "IsEdit": true,
            "IsDelete": true,
            "PkPopupId": this.rowdata.pkPopupId,
            "PopupDescription": this.popupDescription,
            "FkPopupCategoryId": this.data.typeid,
            "SeqNo": this.rowdata.seqNo,
            "IsActive": false,
            "PKSynchId": null
          }
        }
      }

      this.emrservice.InsertHelplistpopup(payload).pipe(takeUntil(this.destroyhelplist$)).subscribe(data => {
        if (data['statusCode'] == 1) {
          this.ngOnInit();
          this.popupDescription = '';
          this.rowdata = {};
          if (this.optypenumber == 1) {
            this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
          } else {
            this.dashboardService.openSnackBar("Record De-Active Successfully", "OK");
          }
          this.optypenumber = 0;
          document.getElementById("updateheliplitsModal").style.display = "None";


        }else if( data['statusCode'] == 10) {
          this.dashboardService.openSnackBar("Already Exists Description", "OK");
        }else if( data['statusCode'] == 7) {
          this.dashboardService.openSnackBar("API Failed", "OK");
        } else {

          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      },
        err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
          // this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");

        }
      );
    } else {
      this.dashboardService.openSnackBar("Plz Enter Description", "OK");
    }
  }
  letterCaseupdate(type) {
  
    if (this.helplistArray.length > 0) {
      if (type == 1) {
        this.helplistArray.forEach(element => {
          var payload = {
            "PopUpMasterGeneral":
            {
              "IsEdit": true,
              "IsDelete": false,
              "PkPopupId": element.pkPopupId,
              "PopupDescription": element.popupDescription.toUpperCase(),
              "FkPopupCategoryId": this.data.typeid,
              "SeqNo": element.seqNo,
              "IsActive": true,
              "PKSynchId": null
            }
          }
           this.emrservice.InsertHelplistpopup(payload).pipe(takeUntil(this.destroyhelplist$)).subscribe(data => {
            if (data['statusCode'] == 1) {
              this.ngOnInit();

            } else {

              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          },
            err => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              } 
              else if(err.error.statusCode == 422){
                this.dashboardService.openSnackBar(err.error.message,"OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
              // this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");

            }
          );
        });

      } else if (type == 2) {
        this.helplistArray.forEach(element => {
          var payload = {
            "PopUpMasterGeneral":
            {
              "IsEdit": true,
              "IsDelete": false,
              "PkPopupId": element.pkPopupId,
              "PopupDescription": this.titleCase(element.popupDescription),
              "FkPopupCategoryId": this.data.typeid,
              "SeqNo": element.seqNo,
              "IsActive": true,
              "PKSynchId": null
            }
          }
          this.emrservice.InsertHelplistpopup(payload).pipe(takeUntil(this.destroyhelplist$)).subscribe(data => {
            if (data['statusCode'] == 1) {
              this.ngOnInit();

            } else {

              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          },
            err => {

              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              } 
              else if(err.error.statusCode == 422){
                this.dashboardService.openSnackBar(err.error.message,"OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }

            }
          );
        });
      }

    } else {
      this.dashboardService.openSnackBar("No Data Found", "OK");
    }
  }
  titleCase(str) {
    return str.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
  }
  // onReviewGrid(desc: any) {
  //   this.dialogRef.close(desc);
  // }
  onReviewGrid(desc: any) {

    if(this.nextreviewrocesses.length >0){
       var newchar ='';
      this.nextreviewrocesses.forEach(item=>{
        newchar = item + ',' + newchar;
      })
      this.dialogRef.close(newchar);
    
    }else{
      this.dialogRef.close(desc);
    }
    //this.dialogRef.close(desc);
  }
  doctorpopup() {
    this.dialogRef.close(0);
  }
  reprocessHomeProcesses(exe, event: any) {
    if (event.checked) {
      this.nextreviewrocesses.push(exe)
    } else {
      var index = this.nextreviewrocesses.indexOf(exe)
      if (index > -1) {
        this.nextreviewrocesses.splice(index, 1);
      }
    }
  }
}
